import { Container } from "react-bootstrap";
import Heading from "../Heading";
import RoundedImg from "../RoundedImg";
import ValueType from "./ValueType";
import valueData from "./valueData.json";

const Value = () => {
  const valueToggler = valueData.valueToggler.map((e, i) => {
    return <ValueType title={e.title} p={e.p} key={i} />;
  });
  const values = valueData.values.map((e, i) => {
    return <Heading h2={e.h2} h3={e.h3} p={e.p} key={i} />;
  });
  return (
    <section className="value-section">
      <Container>
        <div className="row align-items-center justify-content-between pt-5 gap-5">
          <RoundedImg img={require("../../imgs/value.png")} />
          <div className="col-lg-6">
            {values}
            {valueToggler}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Value;
